module.exports = React.addons.TransitionGroup;


//////////////////
// WEBPACK FOOTER
// external "React.addons.TransitionGroup"
// module id = 55
// module chunks = 0